// src/components/ContactForm.js
import React, { useState } from "react";
import { Container, TextField, Button, Typography } from "@mui/material";
import emailjs from "emailjs-com";
import "./ContactForm.css";

const ContactForm = () => {
    const [formData, setFormData] = useState({ name: "", email: "", message: "" });

    const handleSubmit = (e) => {
        e.preventDefault();
        emailjs.send("service_id", "template_id", formData, "user_id")
            .then(() => alert("Message sent successfully!"), () => alert("Failed to send message."));
    };

    return (
        <Container className="contact-container">
            <Typography variant="h4">Fill our enrolment form</Typography>

            <form onSubmit={handleSubmit}>
                <TextField label="Name" fullWidth onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
                <TextField label="Email" fullWidth onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
                <TextField label="Nationality" fullWidth onChange={(e) => setFormData({ ...formData, nationality: e.target.value })} />
                <TextField label="Age" fullWidth onChange={(e) => setFormData({ ...formData, age: e.target.value })} />
                <TextField label="Training " fullWidth onChange={(e) => setFormData({ ...formData, training: e.target.value })} />
                <TextField label="Message" fullWidth multiline rows={4} onChange={(e) => setFormData({ ...formData, message: e.target.value })} />
                <Button type="submit" variant="contained" color="primary">Apply </Button>
            </form>
        </Container>
    );
};

export default ContactForm;
